// import * as mutations from './mutations'
// import * as getters from './getters'
import * as actions from './actions'

import array from '@/store/shared/array'

export default{
  namespaced: true,
  actions,
  modules: {
    array
  }
}
